import script from "./WhyCoachSection.vue?vue&type=script&setup=true&lang=js"
export * from "./WhyCoachSection.vue?vue&type=script&setup=true&lang=js"

import "./WhyCoachSection.vue?vue&type=style&index=0&id=32bbc4f0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32bbc4f0"]])

export default __exports__